import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopSection from "../../LT/TopSection";
import AlertCards from "./AlertCards";
import { getAlertObsoleteSlice } from "../../../redux/actions/getAlertObsoleteSlice";
import {
    getAlerImmutableauditEndpoint,
    getAlertObsoleteEndpoint,
    getBuyerForecastHistoryNotificationsEndpoint,
} from "../../../common/endpoints";
import { Loader } from "../../../components/common/Loader";
import { getAlerImmutableauditSlice } from "../../../redux/actions/getAlerImmutableauditSlice";
import { getBuyerForecastHistoryNotificationsSlice } from "../../../redux/actions/getBuyerForecastHistoryNotificationsSlice";

const AlertsPage = () => {
    const dispatch = useDispatch();
    const [initialLoading, setInitialLoading] = useState(true);
    const [alerts, setAlerts] = useState([]);
    const userEmail = localStorage.getItem("userEmail");
    const alertDataLoading = useSelector(
        (state) => state.getAlertObsoleteSlice?.loading
    );

    useEffect(() => {
        getAlerts();

        const interval = setInterval(() => {
            getAlerts(); // silent refresh
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    const getAlerts = async () => {
        try {
            const [obsoleteResponse, notificationResponse, forecastHistoryNotificationResponse] = await Promise.all([
                dispatch(
                    getAlertObsoleteSlice({
                        dynamicEndpoint: `${getAlertObsoleteEndpoint}/${encodeURIComponent(userEmail)}`,
                        skipUserEmailParam: true,
                    })
                ),
                dispatch(
                    getAlerImmutableauditSlice({
                        dynamicEndpoint: `${getAlerImmutableauditEndpoint}/${encodeURIComponent(userEmail)}`,
                        skipUserEmailParam: true,
                    })
                ),
                dispatch(
                    getBuyerForecastHistoryNotificationsSlice({
                        dynamicEndpoint: `${getBuyerForecastHistoryNotificationsEndpoint}/${encodeURIComponent(userEmail)}`,
                        skipUserEmailParam: true,
                    })
                ),
            ]);
            let allAlerts = [];

            // API 1 - Obsolete Alerts
            if (obsoleteResponse?.meta?.requestStatus === "fulfilled") {
                const obsoleteAlerts = (obsoleteResponse?.payload || []).map(
                    (item) => {
                        let title = "";
                        let description = "";

                        if (item.MESSAGE === "Material is ACTIVE") {
                            title = "Materials are now ACTIVE";
                            description =
                                "This is an alert to notify that the below materials are now active.";
                        } else if (
                            item.MESSAGE === "Material marked as OBSOLETE"
                        ) {
                            title =
                                "Materials have become obsolete/inactive";
                            description =
                                "This is an alert to notify for the materials which have become obsolete.";
                        }

                        return {
                            id: `${item.OBSOLETE_NOTIFICATION_ID}`,
                            type: "obsolete",
                            title,
                            description,
                            alertDate: item.CREATED_AT,
                            status: item.STATUS,
                            material: item.MATERIAL,
                            plant: item.PLANT,
                            purchasingGroup: item.PURCHASING_GROUP,
                            materialDescription:
                                item.MATERIALDESCRIPTION,
                            externalMaterialGroup:
                                item.EXTMATERIALGROUP,
                        };
                    }
                );

                allAlerts = [...allAlerts, ...obsoleteAlerts];
            }

            // API 2 - Supplier Forecast Alerts
            if (notificationResponse?.meta?.requestStatus === "fulfilled") {
                const notificationAlerts = (
                    notificationResponse?.payload || []
                ).map((item) => ({
                    id: `${item.NOTIFICATION_ID}`,
                    type: "notification",
                    title: item.TITLE,
                    description: item.MESSAGE,
                    alertDate: item.CREATED_AT,
                    status: item.STATUS,
                    runMonth: item.RUN_MONTH,
                    recipientType: item.RECIPIENT_TYPE,
                }));

                allAlerts = [...allAlerts, ...notificationAlerts];
            }

            // API 3 - Forecast History Export Notifications
            if (forecastHistoryNotificationResponse?.meta?.requestStatus === "fulfilled") {
                const forecastHistoryAlerts = (
                    forecastHistoryNotificationResponse?.payload || []
                ).map((item) => ({
                    id: `${item.NOTIFICATION_ID}`,
                    type: "forecastHistory",
                    title: (item.TITLE || "Forecast History Notification").trim(),
                    description: (item.MESSAGE || "").trim(),
                    alertDate: item.CREATED_AT,
                    status: item.STATUS,
                    isNew: !!item.isNew,
                    fileName: item.FILE_NAME,
                    fromExtractionDate: item.FROM_EXTRACTION_DATE,
                    toExtractionDate: item.TO_EXTRACTION_DATE,
                    downloadUrl: item.downloadUrl,
                }));

                allAlerts = [...allAlerts, ...forecastHistoryAlerts];
            }

            // Sort latest first
            // allAlerts.sort(
            //     (a, b) =>
            //         new Date(b.alertDate).getTime() -
            //         new Date(a.alertDate).getTime()
            // );

            setAlerts(allAlerts);
        } catch (error) {
            console.error("GET ALERTS ERROR", error);
        } finally {
            setInitialLoading(false);
        }
    };

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Alerts" },
                ]}
                tabTitle="Alerts"
            />

            <div style={{ margin: 10 }}>
                {initialLoading ? (
                    <Loader />
                ) : alerts?.length === 0 ? (
                    <div
                        style={{
                            marginTop: 40,
                            color: "#6b7280",
                        }}
                    >
                        <h3>No alerts available</h3>
                        <p>You don't have any notifications at the moment.</p>
                    </div>
                ) : (
                    alerts.map((alert) => (
                        <div key={alert.id} style={{ marginBottom: 10 }}>
                            <AlertCards alertData={alert} />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AlertsPage;